export default "__VITE_ASSET__BnruEuFM__"